
  import React from 'react';
  import { Table } from 'semantic-ui-react';
  import moment from 'moment';
  
  const PaidInvoices = ({mappedInvoices}) => {

    return (
        <>
            <Table unstackable size="large" compact="very" className="w3-small">
                <Table.Header>
                    <Table.Row >
                        <Table.HeaderCell className="labelName p-bold-600">Invoice Date</Table.HeaderCell>
                        <Table.HeaderCell className="labelName p-bold-600">Customer Invoice No</Table.HeaderCell>
                        <Table.HeaderCell className="labelName p-bold-600">Invoice Due Date</Table.HeaderCell>
                        <Table.HeaderCell className="labelName p-bold-600">Invoice Amount</Table.HeaderCell>
                        <Table.HeaderCell className="labelName p-bold-600">Paid Amount</Table.HeaderCell>
                        <Table.HeaderCell className="labelName p-bold-600">TDS Paid</Table.HeaderCell>

                        {/* <Table.HeaderCell className="labelName p-bold-600">Amount Due</Table.HeaderCell> */}
                    </Table.Row>
                </Table.Header>
                
                <Table.Body>
                    {mappedInvoices && mappedInvoices.map((object, index) => {

                        return (
                            <Table.Row verticalAlign="middle" key={index}>
                                
                                <React.Fragment>                                    
                                    <Table.Cell>
                                        {mappedInvoices[index].invoiceDate ? mappedInvoices[index].invoiceDate : ""}                                                                       
                                    </Table.Cell>
                                    <Table.Cell>
                                        {mappedInvoices[index].customerInvoiceNo}                                                                       
                                    </Table.Cell>
                                    <Table.Cell >
                                        {mappedInvoices[index].invoiceDueDate ? mappedInvoices[index].invoiceDueDate : "NA"}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {mappedInvoices[index].invoiceAmount}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {mappedInvoices[index].paidAmount}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {mappedInvoices[index].tdsPaid}
                                    </Table.Cell>
                                </React.Fragment>  
                            </Table.Row>
                        )
                    }
                )}
                </Table.Body>
            </Table>  
        </>              
      )
  }
  
  export default PaidInvoices
  
  
  
  
  
  
  
  
  
  
                                  
                                      
  
  
  
  
  
  
  
  
  
  
  
  
  
  
